import React from "react";

const Subtitle = ({ children, className = "" }) => (
  <p
    className={`m-0 text-textPrimary font-medium text-[20px] tracking-[-0.06px] leading-[24px] font-['Montserrat','Helvetica','Arial','sans-serif'] block ${className}`}
  >
    {children}
  </p>
);

export default Subtitle;
